module.exports = __webpack_public_path__ + "6cd887ae02e6fea2f4d5c137b719f387.MP3";